import './application'
import './validation'



// WEBPACK FOOTER //
// ./src/js/main.js